export const form = {
  layout: {
    wrapper: 'flex flex-col gap-6',
    content: {
      grid: 'grid grid-cols-1 md:grid-cols-2 gap-4',
      header: {
        wrapper: 'mb-1',
        title: 'text-xl font-medium text-cyan-400 mb-5',
        description: 'text-sm text-cyan-100/70'
      },
      form: 'space-y-4'
    }
  },
  group: {
    wrapper: 'space-y-2',
    fullWidth: 'col-span-1 md:col-span-2',
    label: {
      base: 'block text-sm font-medium text-cyan-100/90',
      required: 'after:content-["*"] after:ml-1 after:text-red-400'
    },
    input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100 placeholder-cyan-100/30',
    error: {
      message: 'text-sm text-red-400'
    }
  },
  variants: {
    select: {
      group: 'space-y-2 relative',
      label: {
        base: 'block text-sm font-medium text-cyan-100/90',
        disabled: 'text-cyan-100/50'
      },
      input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100',
      option: 'bg-gray-900 text-cyan-100 absolute z-[999] !overflow-visible',
      description: 'block mt-2 text-sm text-cyan-100/70'
    },
    form: {
      group: 'space-y-2',
      label: {
        base: 'block text-sm font-medium text-cyan-100/90',
        required: 'after:content-["*"] after:ml-1 after:text-red-400'
      },
      input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100',
      error: {
        message: 'text-sm text-red-400'
      }
    }
  }
} as const;

export type FormTheme = typeof form;